import React from "react";
import Loader from './loader.jsx';

export default function LoaderSection(props) {
    return (
        <div className={`loader-section ${props.className ? props.className : ''}`}>
            <Loader show={props.show}/>
        </div>
    );
}